import React, { lazy, Suspense } from "react";
import Hero from "../components/Hero";
import TrustBadges from "../components/TrustBadges";
import useSEO, {
    localBusinessSchema,
    organizationSchema,
    faqSchema,
    multiLocationFleetSchema,
} from "../lib/seo";
import { VEHICLES } from "../data/vehicles";
import { FAQS } from "../data/faqs";
import { useSiteConfig } from "../lib/siteConfig";

// React streaming prerender waits for this boundary, preserving full crawlable content.
const HomeSections = lazy(() => import("./HomeSections"));

// The homepage covers the complete service network; Satna has its own local page.
export default function HomePage() {
    const config = useSiteConfig();
    useSEO({
        title: "Multi-State Taxi & Tempo Traveller Services | VVPSS",
        description:
            "Book cabs, cars and Tempo Travellers across our service locations in multiple states. Local and outstation travel with driver. Corporate office: Satna.",
        canonical: "https://vvpsstaxiservices.com/",
        ogImage: "https://vvpsstaxiservices.com/og-cover.jpg",
        keywords: "taxi services, cab booking, car hire with driver, car rental, Tempo Traveller hire, Tempo Traveller rental, local taxi, outstation cab, interstate travel",
        schema: [
            organizationSchema(),
            localBusinessSchema(config),
            multiLocationFleetSchema({ vehicles: VEHICLES, url: "https://vvpsstaxiservices.com/" }),
            faqSchema(FAQS),
        ],
    });

    return (
        <>
            <Hero />
            <TrustBadges compact />
            <Suspense fallback={null}>
                <HomeSections />
            </Suspense>
        </>
    );
}
